import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CookieConsent from "./CookieConsent";
import CookiePolicy from "./CookiePolicy";
import { setDefaultConsent } from "./gtm";
import Landing from "./Landing";
import PrivacyPolicy from "./PrivacyPolicy";
import "./styles.css";

const params = new URLSearchParams(window.location.search);
const partner = params.get("partner") ?? "halavach";

// Inside a partner-page iframe → bare calculator card + height reporting.
// Opened directly (ads / direct traffic) → full landing around the calculator.
const embedded = window.self !== window.top;

function EmbedShell() {
  useEffect(() => {
    const postHeight = () =>
      window.parent.postMessage(
        { type: "wyceniarka_resize", height: document.body.scrollHeight },
        "*"
      );
    postHeight();
    const observer = new ResizeObserver(postHeight);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="p-4 bg-brand-50 flex justify-center">
      <App partner={partner} />
    </div>
  );
}

if (!embedded) {
  // Consent Mode v2: all Google signals start "denied" before GTM can load.
  setDefaultConsent();
}

function Page() {
  if (window.location.pathname === "/polityka-prywatnosci") {
    return <PrivacyPolicy />;
  }
  if (window.location.pathname === "/polityka-cookies") {
    return <CookiePolicy />;
  }
  if (embedded) {
    return <EmbedShell />;
  }
  return (
    <>
      <Landing partner={partner} />
      <CookieConsent />
    </>
  );
}

const root = document.getElementById("root")!;
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);
